/* KIDSpo グローバルメニュー: メガ(PC) + 全画面(モバイル)
   2026-10-08 全面改訂（テーマ7回目）
   - パネルの位置: 開くたびにヘッダーの行（header.header）の下端に合わせる（お知らせバー・追従ヘッダーでずれない）。
   - 重なり: 開いている間はヘッダーの区画を前面に（.kidspo-mega-open）。一覧の絞り込みバーより上に出る。
   - ホバー: 少し待ってから開く（横切っただけでは開かない）。開いている間の切り替えも少し待つ（斜めに下ろしたとき隣が開かない）。
   - クリック: 売り場名はページへ移動。⌄ ボタン・カジュアル・ブランドはパネルの開閉。タッチは1回目で開き、2回目で移動。
   - キーボード: ⌄ ボタンで開くとパネルの先頭へ。↓でも開く。Esc で閉じて元の位置へ。パネルの最後から Tab で次の項目へ。
   - 閉じる: ポインタが離れたとき・背景のクリック・Esc・フォーカスが外れたとき・40px以上のスクロール・990px未満への縮小。 */
(function () {
  'use strict';

  /* ---------- desktop mega ---------- */
  var nav = document.querySelector('[data-kidspo-nav]');
  var mega = document.querySelector('[data-kidspo-mega]');
  var backdrop = document.querySelector('[data-kidspo-mega-backdrop]');
  var section = nav ? nav.closest('.section-header') : null;
  var row = nav ? nav.closest('header') : null;
  var OPEN_DELAY = 90, SWITCH_DELAY = 120, CLOSE_DELAY = 220;
  var openId = null, openTimer = null, closeTimer = null, liftTimer = null, scrollY0 = 0, lastPointer = 'mouse';
  var desktop = window.matchMedia('(min-width: 990px)');

  function panelOf(id) { return mega ? mega.querySelector('[data-kidspo-panel="' + id + '"]') : null; }
  function liOf(id) { return nav ? nav.querySelector('[data-kidspo-li="' + id + '"]') : null; }
  function toggleOf(id) { var li = liOf(id); return li ? li.querySelector('[data-kidspo-toggle]') : null; }
  function focusables(root) {
    return root ? Array.prototype.slice.call(root.querySelectorAll('a[href], button:not([disabled])')) : [];
  }

  function place() {
    if (!row || !mega) return;
    var top = Math.max(0, Math.round(row.getBoundingClientRect().bottom));
    mega.style.top = top + 'px';
    mega.style.maxHeight = Math.max(240, window.innerHeight - top - 12) + 'px';
    if (backdrop) backdrop.style.top = top + 'px';
  }

  function markOpen(id) {
    nav.querySelectorAll('[data-kidspo-li]').forEach(function (li) {
      var on = li.getAttribute('data-kidspo-li') === id;
      li.classList.toggle('is-open', on);
      var t = li.querySelector('[data-kidspo-toggle]');
      if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }

  function open(id) {
    clearTimeout(openTimer); clearTimeout(closeTimer); clearTimeout(liftTimer);
    if (!desktop.matches || !panelOf(id) || openId === id) return;
    place();
    var switching = !!openId;
    mega.querySelectorAll('[data-kidspo-panel]').forEach(function (p) {
      p.hidden = p.getAttribute('data-kidspo-panel') !== id;
    });
    openId = id;
    markOpen(id);
    if (section) section.classList.add('kidspo-mega-open');
    mega.classList.toggle('is-switch', switching);
    mega.classList.add('is-show');
    if (backdrop) backdrop.classList.add('is-show');
    scrollY0 = window.pageYOffset;
  }

  function close(focusBack) {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (!openId) return;
    var id = openId;
    openId = null;
    markOpen(null);
    mega.classList.remove('is-show', 'is-switch');
    if (backdrop) backdrop.classList.remove('is-show');
    // 消える間は前面のまま（すぐ戻すと、消えかけのパネルに絞り込みバーが重なる）
    liftTimer = setTimeout(function () { if (!openId && section) section.classList.remove('kidspo-mega-open'); }, 320);
    if (focusBack) {
      var t = toggleOf(id);
      if (t) t.focus();
    }
  }

  function scheduleClose() {
    clearTimeout(openTimer); clearTimeout(closeTimer);
    if (openId) closeTimer = setTimeout(function () { close(false); }, CLOSE_DELAY);
  }

  function focusFirst(id) {
    var f = focusables(panelOf(id));
    if (f.length) f[0].focus();
  }

  if (nav && mega) {
    document.addEventListener('pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; }, { capture: true, passive: true });

    nav.querySelectorAll('.kidspo-nav__li').forEach(function (li) {
      var id = li.getAttribute('data-kidspo-li');
      li.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch') return;
        clearTimeout(closeTimer); clearTimeout(openTimer);
        if (id) {
          openTimer = setTimeout(function () { open(id); }, openId ? SWITCH_DELAY : OPEN_DELAY);
        } else if (openId) {
          openTimer = setTimeout(function () { close(false); }, SWITCH_DELAY); // 新着・SALE など、パネルの無い項目
        }
      });
      li.addEventListener('pointerleave', function (e) {
        if (e.pointerType === 'touch') return;
        clearTimeout(openTimer);
      });
    });
    nav.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') scheduleClose(); });
    mega.addEventListener('pointerenter', function () { clearTimeout(closeTimer); clearTimeout(openTimer); });
    mega.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') scheduleClose(); });
    if (backdrop) backdrop.addEventListener('click', function () { close(false); });

    // 売り場名（リンク）: タッチは1回目でパネル、2回目で移動。キーボードの↓でパネルを開く
    nav.querySelectorAll('[data-kidspo-open]').forEach(function (a) {
      var id = a.getAttribute('data-kidspo-open');
      a.addEventListener('click', function (e) {
        if (lastPointer === 'touch' && desktop.matches && openId !== id) { e.preventDefault(); open(id); }
      });
      a.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(id); focusFirst(id); }
      });
    });

    // ⌄ ボタン・カジュアル・ブランド
    nav.querySelectorAll('[data-kidspo-toggle]').forEach(function (b) {
      var id = b.getAttribute('data-kidspo-toggle');
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var keyboard = e.detail === 0;
        if (keyboard || lastPointer === 'touch') {
          if (openId === id) { close(keyboard); }
          else { open(id); if (keyboard) focusFirst(id); }
        } else {
          open(id); // マウス: ホバーで開いた直後のクリックで閉じない
        }
      });
      b.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown') { e.preventDefault(); open(id); focusFirst(id); }
      });
    });

    // パネル内のキーボード: Esc で戻る。最後から Tab で次の項目、先頭から Shift+Tab でボタンへ
    mega.addEventListener('keydown', function (e) {
      if (!openId) return;
      if (e.key === 'Escape') { e.preventDefault(); close(true); return; }
      if (e.key !== 'Tab') return;
      var f = focusables(panelOf(openId));
      if (!f.length) return;
      var li = liOf(openId);
      if (!e.shiftKey && document.activeElement === f[f.length - 1]) {
        e.preventDefault();
        var next = li && li.nextElementSibling ? li.nextElementSibling.querySelector('a[href], button') : null;
        close(false);
        if (next) next.focus();
      } else if (e.shiftKey && document.activeElement === f[0]) {
        e.preventDefault();
        var t = toggleOf(openId);
        if (t) t.focus();
      }
    });
    nav.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && openId) { e.preventDefault(); close(true); }
    });

    // フォーカスやクリックがメニューの外へ出たら閉じる
    document.addEventListener('focusin', function (e) {
      if (openId && !nav.contains(e.target) && !mega.contains(e.target)) close(false);
    });
    document.addEventListener('click', function (e) {
      if (openId && !nav.contains(e.target) && !mega.contains(e.target)) close(false);
    });

    window.addEventListener('scroll', function () {
      if (openId && Math.abs(window.pageYOffset - scrollY0) > 40) close(false);
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!openId) return;
      if (!desktop.matches) close(false); else place();
    });
  }

  /* ---------- mobile full-screen menu ---------- */
  var mmenu = document.querySelector('[data-kidspo-mmenu]');
  var openers = document.querySelectorAll('[data-kidspo-menu-open]');
  var lastFocus = null;

  function openMenu() {
    if (!mmenu) return;
    lastFocus = document.activeElement;
    mmenu.hidden = false;
    document.body.classList.add('kidspo-menu-lock');
    requestAnimationFrame(function () { mmenu.classList.add('is-open'); });
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'true'); });
    var x = mmenu.querySelector('.kidspo-mmenu__x');
    if (x) { try { x.focus(); } catch (e) {} } // 検索欄に入れるとキーボードが開くので、閉じるボタンへ
  }
  function closeMenu() {
    if (!mmenu) return;
    mmenu.classList.remove('is-open');
    document.body.classList.remove('kidspo-menu-lock');
    openers.forEach(function (o) { o.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { mmenu.hidden = true; }, 300);
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} }
  }
  openers.forEach(function (o) { o.addEventListener('click', openMenu); });
  document.querySelectorAll('[data-kidspo-menu-close]').forEach(function (c) {
    c.addEventListener('click', closeMenu);
  });

  if (mmenu) {
    mmenu.querySelectorAll('[data-kidspo-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-kidspo-acc');
        var panel = document.getElementById('kidspo-acc-' + id);
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (panel) panel.hidden = isOpen;
      });
    });
    // 990px以上に広げたら閉じる（PCのメニューに切り替わるため）
    desktop.addEventListener('change', function (e) { if (e.matches && !mmenu.hidden) closeMenu(); });
  }

  /* ---------- keyboard: ESC + focus trap (mobile) ---------- */
  document.addEventListener('keydown', function (e) {
    if (!mmenu || mmenu.hidden) return;
    if (e.key === 'Escape') { closeMenu(); return; }
    if (e.key === 'Tab') {
      var f = Array.prototype.filter.call(
        mmenu.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
})();
